import type { QuoteVideoRecord } from '@benzinga/videos-manager';

const secondsToISO8601Duration = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  let duration = 'PT';
  if (hours) duration += `${hours}H`;
  if (minutes) duration += `${minutes}M`;
  // Always emit a seconds component when there is no hours/minutes part so the
  // value is a valid, non-empty ISO 8601 duration (e.g. a 0s clip -> `PT0S`).
  if (secs || (!hours && !minutes)) duration += `${secs}S`;

  return duration;
};

export const buildVideoObjectSchema = (record: QuoteVideoRecord) => ({
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  contentUrl: `https://www.youtube.com/watch?v=${record.videoId}`,
  description: record.description,
  duration: secondsToISO8601Duration(record.durationSeconds),
  embedUrl: `https://www.youtube.com/embed/${record.videoId}`,
  name: record.title,
  thumbnailUrl: record.thumbnailUrl,
  uploadDate: record.publishedAt,
});
